import { useGlobalShortcutsDataBFF } from './useGlobalShortcutsDataBFF';
export { useGlobalShortcutsDataRelay } from './useGlobalShortcutsDataRelay';
export { useGlobalShortcutsDataBFF } from './useGlobalShortcutsDataBFF';

// Export the BFF version of the hook for backward compatibility
export const useGlobalShortcutsData = useGlobalShortcutsDataBFF;
